import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import {useTranslation} from "react-i18next";
import { ISaveModal } from "./types";

const SaveModal = ({infoForm, onSubmit, openState, setIsDisabled}: ISaveModal) => {
    const {t} = useTranslation(["network", "translation"]);
    
    const [open, setOpen] = openState;

    const updateHandler = () => {
        setOpen(false);
        setIsDisabled(true);
        infoForm.handleSubmit(onSubmit)();
    }

    return(
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("rsDetail.tabWrapper.dialog.title")}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("rsDetail.tabWrapper.dialog.content")}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                    {t("rsDetail.tabWrapper.dialog.action.cancel")}
                </Button>
                <Button onClick={() => updateHandler()} autoFocus>
                    {t("rsDetail.tabWrapper.dialog.action.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SaveModal;
